// Eski renkler (geriye uyumluluk için)
export const innerColor = '#ffffff';
export const themeColor = '#232F3E';

// Modern Tasarım Sistemi - Uygulama Geneli
export const modernDesignSystem = {
  colors: {
    primary: {
      main: '#2E7D32',      // Modern yeşil - tarım teması
      dark: '#1B5E20',      // Koyu yeşil
      light: '#66BB6A',     // Açık yeşil
      surface: '#E8F5E8'    // Çok açık yeşil yüzey
    },
    secondary: {
      main: '#388E3C',      // Orta yeşil (turuncu yerine)
      dark: '#2E7D32',      // Koyu orta yeşil
      light: '#66BB6A',     // Açık orta yeşil
      surface: '#F1F8E9'    // Çok açık orta yeşil yüzey
    },
    tertiary: {
      main: '#43A047',      // Üçüncül yeşil tonu
      dark: '#2E7D32',      // Koyu üçüncül yeşil
      light: '#81C784',     // Açık üçüncül yeşil
      surface: '#F3E5F5'    // Çok açık üçüncül yüzey
    },
    neutral: {
      white: '#FFFFFF',
      gray50: '#FAFAFA',
      gray100: '#F5F5F5',
      gray200: '#EEEEEE',
      gray300: '#E0E0E0',
      gray400: '#BDBDBD',
      gray500: '#9E9E9E',
      gray600: '#757575',
      gray700: '#616161',
      gray800: '#424242',
      gray900: '#212121'
    },
    accent: {
      blue: '#1976D2',      // Mavi vurgu
      darkGreen: '#1B5E20', // Koyu yeşil vurgu
      teal: '#00695C',      // Teal vurgu
      red: '#D32F2F'        // Kırmızı vurgu
    },
    semantic: {
      success: '#2E7D32',
      warning: '#F57C00',
      error: '#D32F2F',
      errorLight: '#FFEBEE',
      info: '#1976D2'
    },
    error: {
      main: '#D32F2F',
      light: '#FFEBEE',
      dark: '#B71C1C'
    }
  },
  shadows: {
    soft: '0 1px 3px rgba(0, 0, 0, 0.08)',
    subtle: '0 2px 4px rgba(0, 0, 0, 0.05)',
    medium: '0 4px 12px rgba(0, 0, 0, 0.10)',
    elevated: '0 8px 24px rgba(0, 0, 0, 0.15)',
    heavy: '0 16px 48px rgba(0, 0, 0, 0.20)'
  },
  borders: {
    radius: {
      small: '6px',
      medium: '12px',
      large: '16px',
      xl: '20px',
      full: '9999px'
    }
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  },
  typography: {
    fontFamily: {
      primary: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      secondary: '"Poppins", sans-serif'
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem'
    }
  }
};
